// extracted by mini-css-extract-plugin
export var button = "styles-module--button--0UOuj";
export var blue = "styles-module--blue--5OG6i";
export var white = "styles-module--white--YTQlp";